module.exports = __webpack_public_path__ + "static/media/te-rangihakahaka-bg-1350x900.0623fbf0.jpg";